<template>
  <cargo-dialog
    ref="priceViewDialog"
    custom-class="price-view-dialog"
    :visible="visible"
    :title="$t('CargoMsg.Cargo_OpenPriceInfo')"
    width="1408px"
    top="5vh"
    :can-maximize="source==='priceBatch'"
    :source="source"
    @close="cancelHandler"
  >
    <open-price-view
      v-if="visible"
      ref="priceViewPop"
      source="priceViewDialog"
      :only-view="true"
    />
    <div slot="footer">
      <el-button no="Cancel" @click="cancelHandler">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
    </div>
  </cargo-dialog>
</template>

<script>
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import openPriceView from '@/views/cargo/v0/Price/OpenPriceBatch/components/openPriceView'

export default {
  name: 'PriceViewDialog',
  components: { CargoDialog, openPriceView },
  props: {
    visible: { type: Boolean, required: true },
    priceBatch: { type: Object, required: true }, // 备案批次
    source: { type: String, default: 'priceBatch' }
  },
  data() {
    return { }
  },
  methods: {
    toDetail() {
      if (!this.priceBatch) {
        return
      }
      this.$nextTick(() => {
        this.$refs.priceViewPop.originForm = this.priceBatch
        this.$refs.priceViewPop.form = this.priceBatch
        this.$refs.priceViewPop.init()
      })
    },
    cancelHandler() {
      this.$emit('close')
      if (this.source === 'priceBatch') {
        this.destroySelf()
      }
    }
  }
}
</script>

<style lang="scss">
.price-view-dialog {
  .el-dialog__body{
    padding: 0px 5px 0px;
    min-height: 650px;
  }
  .el-dialog__footer{
    padding: 5px;
  }
  .el-form-item {
    margin:0 !important;
  }
}
</style>
